import { render, staticRenderFns } from "./GoogleIcon.vue?vue&type=template&id=62dcf4ec&scoped=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dcf4ec",
  null
  
)

export default component.exports